export const isAlphaNumeric = (value: string) => /[a-zA-Z0-9]{1}/g.test(value)
